module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"diffKeys":["","Original","Incoming"]}}')
  delete Component.options._Ctor
}
